<template>
  <section class="teams">
    <title-bg></title-bg>
      <a-spin :spinning="loading" tip="Loading..." :delay="500" style="min-height: 70px;">
        <a-descriptions title="" bordered style="margin:26px auto;">
          <a-descriptions-item label="证件照">
            <img :src="sourceBaseUrl + userInfo.id_photo" alt="" v-if="userInfo.id_photo != null && userInfo.id_photo != ''">
            <img :src="IdPhotoDefault" alt="" v-else>
          </a-descriptions-item>
          <a-descriptions-item label="姓名">
            {{userInfo.teacher_name}}
          </a-descriptions-item>
          <a-descriptions-item label="性别">
            <span v-if="userInfo.user_sex == 1">男</span>
            <span v-else-if="userInfo.user_sex == 2">女</span>
            <span v-else>未知</span>
          </a-descriptions-item>
          <a-descriptions-item label="院内外">
            <span v-if="userInfo.is_source == 1">院内</span>
            <span v-else-if="userInfo.is_source == 2">院外</span>
            <span v-else>未知</span>
          </a-descriptions-item>
          <a-descriptions-item label="涉及专业">
            {{userInfo.profession_names}}
          </a-descriptions-item>
          <a-descriptions-item label="教授课程">
            {{userInfo.class_names}}
          </a-descriptions-item>
          <a-descriptions-item label="个人简介">
            <span v-if="userInfo.user_desc != '' && userInfo.user_desc != null">{{userInfo.user_desc}}</span>
            <span v-else>无</span>
          </a-descriptions-item>
        </a-descriptions>
      </a-spin>
  </section>
</template>
<script>
import TitleBg from '../../../components/TitileBg'
import {TeacherDetail} from '../../../common/teachers/TeacherDetail'
export default {
  mixins: [TeacherDetail],
  components: {
    TitleBg,
  },
}
</script>
<style lang="less" scoped>
.teams{
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  &-address{
    display: flex;
    align-items: center;
    margin: 43px 0 23px;
    height: 38px;
    width: 379px;
    background: #fff;
    border: 1px solid #D1D1D1;
    border-radius: 4px;
    &-icon{
      border-right: 1px solid #D1D1D1;
      width: 57px;
      height: 100%;
      background: url('../../../assets/image/address-icon.png') no-repeat center center;
      background-size: 14px 17px;
      box-sizing: border-box;
    }
    & /deep/ .ant-select{
      width: 245px;
      border: none;
      height: 100%;
      box-sizing: border-box;
      font-size: 12px;
      color: #000;
      &-selection {
        border: none;
        height: 100%;
        box-sizing: border-box;
        &__rendered{
          height: 100%;
          line-height: 36px;
        }
      }
    }
    &-button{
      height: 100%;
      width: 77px;
      background: #C16613;
      border:none;
      border-radius: 0;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
  &-list{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 78px;
    &-item{
      display: flex;
      flex-direction: column;
      margin-bottom: 10px;
      width: 179px;
      cursor: pointer;
      &-image{
        width: 179px;
        height: 99px;
        background: #ccc;
      }
      &-content{
        display: flex;
        align-items: center;
        padding: 10px 0;
        background: #fff;
        &-flag{
          margin-right: 9px;
          // width:58px;
          width:70px;
          height:20px;
          line-height: 20px;
          font-size:14px;
          font-weight:400;
          text-align: center;
          color:rgba(255,255,255,1);
          background:rgba(153,108,51,1);
          border-radius:9px;
        }
        &-name{
          font-size:14px;
          font-weight:400;
          color:rgba(0,0,0,1);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  img{
    max-width: 100%;
  }
}
</style>
